import React from 'react';
import { Wine, PlusCircle, Search, Filter, Tag } from 'lucide-react';

const WineListToolbar = ({ 
    onToggleForm, 
    showForm,
    search,
    onSearchChange,
    activeFilter,
    onFilterChange,
    selectedWines = [],
    onShowBulkTagModal
}) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="row align-items-center">
                    <div className="col-auto d-flex align-items-center">
                        <Wine size={24} className="me-2" />
                        <h5 className="mb-0">Wine List</h5>
                    </div>
                    
                    <div className="col">
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by varietal or grower..."
                                value={search}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                            <select 
                                className="form-select" 
                                style={{ maxWidth: '200px' }}
                                value={activeFilter}
                                onChange={(e) => onFilterChange(e.target.value)}
                            >
                                <option value="1">Active Wines</option>
                                <option value="0">Archived Wines</option>
                                <option value="all">All Wines</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-auto btn-group">
                        <button 
                            className="btn btn-outline-secondary"
                            disabled={selectedWines.length === 0}
                            onClick={onShowBulkTagModal}
                        >
                            <Tag size={16} className="me-1" />
                            {selectedWines.length > 0 ? `Manage Tags (${selectedWines.length})` : 'Manage Tags'}
                        </button>
                        <button 
                            className="btn btn-outline-primary"
                            onClick={onToggleForm}
                            title={showForm ? 'Hide Form' : 'New Wine'}
                        >
                            <PlusCircle size={18} className="me-2" />
                            {showForm ? 'Hide Form' : 'New Wine'}
                        </button>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
                
                .input-group-text {
                    background-color: white;
                    border-right: none;
                }
                
                .input-group .form-control {
                    border-left: none;
                }
                
                .input-group .form-control:focus {
                    border-left: none;
                    box-shadow: none;
                }
            `}</style>
        </div>
    );
};

export default WineListToolbar;